import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { List, Datagrid, TextField, useListContext, useRecordContext, ImageField } from 'react-admin';

import IntroSection from './intro';

const TruncatedDataField = ({ source, chars = 3 }) => { // TODO: make it a common component
    const record = useRecordContext();
    if (!record) return null;

    const value = record[source];
    if (!value) return null;

    return (
        <Box sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
            {value.length > (chars * 2 + 3) 
                ? `${value.slice(0, chars)}..${value.slice(-chars)}`
                : value
            }
        </Box>
    );
};

const NFTListView = () => {
    const { data, isLoading, error } = useListContext();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    if (!data || data.length === 0) {
        return <div>No records found</div>;
    }

    // Calculate random values for demo purpose

    const collectionSize = Math.floor(Math.random() * 1000);
    const tokenPrice = (Math.random() * 100 + 100).toFixed(2);
    const collectionValue = (collectionSize * tokenPrice).toFixed(2);
   
    // sold
    const sold = Math.floor(Math.random() * collectionSize);
     // available 
     const available = collectionSize - sold;
    // reserved
    // const reserved = available - sold;
    // royalty
    // const royalty = Math.floor(Math.random() * 10);
    // royalty_fee
    const royalty_fee = 0.025;
    // royalty_value
    const royalty_value = (collectionValue * royalty_fee).toFixed(2);


    return (
        <Box sx={{ width: '100%', maxWidth: '100vw', overflow: 'hidden' }}>
            <Box sx={{ p: { xs: 0, sm: 2 } }}>
                <IntroSection />
                <Card>
                    <Datagrid size="small">
                        <ImageField 
                            source="image" 
                            label="Image"
                            // Add title to show on hover
                            title="metadata.image"
                            // Add styling for consistent image sizes
                            sx={{
                                '& img': {
                                    maxWidth: '100px',
                                    height: 'auto',
                                    objectFit: 'contain'
                                }
                            }}
                        />
                        {/* <TextField source="contract_address" label="Address" /> */}
                        <TextField source="contract_name" label="Name" />
                        <TextField source="contract_symbol" label="Symbol" />
                        <TruncatedDataField source="contract_address" chars="6" label="Contract Address" />
                        
                        <TextField source="collection_size" label="Collection Size"  />
                        <TextField source="token_price" label="Min. Token Price"  />
                        <TextField source="collection_value" label="Collection Value" />

                        {/* <TextField source="collection.total" label="Total" /> */}
                        <TextField source="available" label="Available" defaultValue={available} />
                        <TextField source="sold" label="Sold" defaultValue={sold} />
                        {/* <TextField source="reserved" label="Reserved" defaultValue={reserved} /> */}
                        {/* <TextField source="royalty" label="Royalty" defaultValue={royalty}/> */}
                        <TextField source="royalty_fee" label="Royalty Fee" defaultValue={royalty_fee}/>
                        <TextField source="royalty_value" label="Royalty Value" defaultValue={royalty_value} />



                    </Datagrid>
                </Card>

            </Box>
        </Box>
    );
};


export const NFTList = props => (
    <List {...props}>
        <NFTListView />
    </List>
);

export default NFTList;